<form
    novalidate
    #propertyPhotoSectionForm="ngForm"
    *ngIf="draftLoaded$ | async"
>
    <tg-row>
        <tg-col md="6" sm="12">
            <tm-list-photo-management
                name="photos"
                ngModel
                [photos]="photos"
                (photoSelected)="onPhotoSelected($event)"
                (photosUpdated)="onPhotosUpdated($event)"
                (photoTransformed)="onPhotoTransformed($event)"
            >
            </tm-list-photo-management>
        </tg-col>
    </tg-row>
</form>
